import { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

/**
 * Smoothly counts up to `value`. Used for token balances, KPIs, etc.
 */
export function NumberTicker({ value, duration = 1.1, format, className = "", testid }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (latest) => Math.round(latest));
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(mv, Number(value) || 0, {
      duration,
      ease: [0.22, 1, 0.36, 1],
    });
    const unsub = rounded.on("change", (n) => setDisplay(n));
    return () => {
      controls.stop();
      unsub();
    };
  }, [value, duration, mv, rounded]);

  return (
    <motion.span data-testid={testid} className={className}>
      {format ? format(display) : display.toLocaleString()}
    </motion.span>
  );
}
